export default "__VITE_ASSET__DzoCZBzC__"